'use client'

import { LuneTheme } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import Enfuce from '@public/images/logos/enfuce.png'
import GoCardless from '@public/images/logos/gocardless.png'
import Paymix from '@public/images/logos/paymix.png'
import TrueLayer from '@public/images/logos/truelayer.png'
import Visa from '@public/images/logos/visa.png'

import LogosGrid from '@/components/LogosGrid'

const logos = [
    {
        name: 'Visa',
        img: Visa,
        width: 52.45,
        height: 17,
    },
    {
        name: 'GoCardless',
        img: GoCardless,
        width: 122.28,
        height: 18,
    },
    {
        name: 'TrueLayer',
        img: TrueLayer,
        width: 140.53,
        height: 24,
    },
    {
        name: 'Enfuce',
        img: Enfuce,
        width: 106.68,
        height: 38,
    },
    {
        name: 'Paymix',
        img: Paymix,
        width: 111.02,
        height: 32,
    },
]

const PaymentsLogos = () => {
    const { palette } = LuneTheme
    return (
        <Box
            sx={{
                position: 'relative',
                '&:after': {
                    content: '""',
                    position: 'absolute',
                    bottom: 0,
                    left: '-50%',
                    right: '-50%',
                    height: '1px',
                    backgroundColor: `${palette.Grey300}`,
                    mx: {
                        lg: 37,
                        xl: 37,
                    },
                },
            }}
        >
            <LogosGrid sx={{ pt: 6, pb: 6 }} logos={logos} />
        </Box>
    )
}

export default PaymentsLogos
